









import { defineComponent } from "@vue/composition-api";
import BaseIcon from "@/components/BaseIcon";

export default defineComponent({
  name: "FullscreenArrow",
  components: { BaseIcon },
  props: {
    prev: { type: Boolean },
    next: { type: Boolean },
  },
});
